import React from 'react'
import NumberFormat from 'react-number-format'
import Moment from 'moment';
import { H4 } from './Text'
import ReactTooltip from 'react-tooltip'

const CompanyInfo = ({reutersData, symbol}) => {
  const liClass = "f6 fl w-50 pv0 ph3 dib"
  const padding = "bt b--light-gray cf border-box pv2"
  const left = "fl gray"
  const right = "fr"


  this.dynamicOps = reutersData.DynamicOps;
  this.opsType = "Stable";

 if (this.dynamicOps === 0) {
      this.opsType = "Stable"; 
 } else {
      this.opsType = "Dynamic";
 }
  
  console.log(reutersData);

  return (
    <div className="br2 cf bg-white shadow-custom">
      <div className="pa3 cf">  
        <span><a className="link blue" href={reutersData.web_addr} target="_blank"> <H4>Company Information</H4></a></span>
        <span className="fr">View More: 
          {symbol === "BRK-A" ? (
            <a className="link blue" href={`https://money.cnn.com/quote/forecast/forecast.html?symb=BRKA`} target="_blank"> CNN Money, </a>
            ) : (
            <a className="link blue" href={`https://money.cnn.com/quote/forecast/forecast.html?symb=${symbol}`} target="_blank"> CNN Money,  </a>
          )}  
       <a className="link blue" href={`https://www.msn.com/en-us/money/markets`} target="_blank">MSN Money, </a>
       <a className="link blue" href={`https://stockanalysis.com/stocks/${symbol}/forecast/`} target="_blank">Stock Analysis</a>
      </span>
      </div>
      <ul className="list ma0 pa0 cf">
        <li className={liClass}>
          <div className={padding}><span className={left}>Sector:</span>
          <span className={right}>{reutersData.smg_desc}</span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}>Industry:</span>
          <span className={right}>{reutersData.img_desc}</span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}>Market Cap:</span>
          <span className={right}>
            <NumberFormat value={reutersData.marketCap/1000} decimalPrecision={3} displayType={'text'} prefix={'$'} suffix={' B'}/>
          </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}>Employees:</span>
          <span className={right}>
            <NumberFormat value={reutersData.employees} displayType={'text'} thousandSeparator={true}/>
          </span></div>
        </li>
        <li className={liClass}>
          {reutersData.perend_y1 === null ? (
            <div className={padding}><span className={left}>Fiscal Year End Date:</span></div>
            ) : (
            <div className={padding}><span className={left}>Fiscal Year End Date:</span>
            <span className={right}>{Moment(reutersData.perend_y1).format('MM/DD/YY')}</span></div>
          )}
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}> <a className="link blue" href={` http://www.multpl.com/s-p-500-historical-prices`} target="_blank">SP500:</a></span>
          <i data-tip data-for='SP500' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='SP500' place='top' class='mw6'>
            <p className="f6">The 500 stocks in the SP500 index represent less than 8% of the stocks traded on the US stock markets, but over 70% of the market capitalization. The SP500 index is dominated by 10 companies that account for 25% of its market capitalization.</p>
          </ReactTooltip>
          {reutersData.SP_DESC === "500" ? (
            <span className={right}>{"Yes"}</span>
            ) : (
            <span className={right}>{"No"}</span>
            )}
            </div>
        </li>
        <li className={liClass}>
          {reutersData.divnqxdt === null ? (
            <div className={padding}><span className={left}>Ex Dividend Date:</span></div>
            ) : (
            <div className={padding}><span className={left}>Ex Dividend Date:</span>
            <span className={right}>{Moment(reutersData.divnqxdt).format('MM/DD/YY')}</span></div>
            )}
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}> <a className="link blue" href={`https://finance.yahoo.com/quote/${symbol}`} target="_blank">Dividend Yield:</a></span>
          <i data-tip data-for='DY' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='DY' place='top' class='mw6'>
            <p className="f6">Dividend Yield = Dividend / Price</p>
            <p>Annual Dividend is the latest quarterly dividend multiplied by 4. Price is as market close from previous Friday.</p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.divYield * 100} decimalPrecision={2} displayType={"text"} suffix={"%"} />
          </span></div>
        </li>
        <li className={liClass}>
          {reutersData.repdt_q0 === null ? (
            <div className={padding}><span className={left}>Earnings Date:</span></div>
            ) : (
              
              <div className={padding}>
              
              {symbol === "BRK-A" ? (
                 <span className={left}> <a className="link blue" href={`https://www.zacks.com/stock/research/BRK.A/earnings-announcements`} target="_blank">Earnings Date:</a></span>
              ):(
                <span className={left}> <a className="link blue" href={`https://www.zacks.com/stock/research/${symbol}/earnings-announcements`} target="_blank">Earnings Date:</a></span> 
              )} 

          <i data-tip data-for='ED' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='ED' place='top' class='mw6'>
            <p className="f6">To view the upcoming Expected Earnings Date while on the Zacks website, click on stock symbol at top of window, this will take you to the quote overview window. Expected Earnings Date is in the Key Earnings Data section on the quote overview window.</p>
          </ReactTooltip>

            <span className={right}>{Moment(reutersData.repdt_q0).format('MM/DD/YY')}</span></div>
          )}  
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}>Avg. Daily Volume:</span>
          <i data-tip data-for='ADV' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='ADV' place='top' class='mw6'>
            <p className="f6">Average daily trading volume over the preceding 10 trading days.</p>
          </ReactTooltip>
          <span className={right}>
          <NumberFormat value={reutersData.avd_10d} displayType={'text'} thousandSeparator={true} suffix={" K"}/>
        </span></div>
        </li>
        <li className={liClass}>
        <div className={padding}>
        {symbol === "BRK-A" ? (
          <span className={left}> <a className="link blue" href={`https://www.morningstar.com/stocks/xnys/brk.a/quote`} target="_blank">Avg. Sales to Equity:</a></span> 
        ):(
          <span className={left}> <a className="link blue" href={`https://www.morningstar.com/stocks/${reutersData.MorningStarTicker}/quote`} target="_blank">Avg. Sales to Equity:</a></span> 
        )}
          <i data-tip data-for='SE' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='SE' place='top' class='mw6'>
            <p className="f6">Sales to Equity is sales generated from additional dollar of equity. 1 – ( (Sales Growth / Sales to Equity)/PM) used to approximate Distribution Rate.</p>
            <p>Note: Distribution Rate = FCFE/NI.  FCFE = (NI + Net Debt) – New Investment. FCFE used to pay dividends, buyback shares, and park excess in cash.</p>
            <p>Note: Sales to Equity = ROE/PM</p>
          </ReactTooltip>
          <span className={right}>
          <NumberFormat value={reutersData.SalesToEquity} displayType={'text'} decimalPrecision={1}/>
        </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}>
          {symbol === "BRK-A" ? (
            <span className={left}> <a className="link blue" href={`https://www.zacks.com/stock/quote/BRK.A/financial-overview`} target="_blank">Avg. Debt/Equity:</a></span>
          ):(
            <span className={left}> <a className="link blue" href={`https://www.zacks.com/stock/quote/${symbol}/financial-overview`} target="_blank">Avg. Debt/Equity:</a></span> 
          )}
          <i data-tip data-for='DE' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='DE' place='top' class='mw6'>
            <p className="f6">Debt to Equity (D/E) ratio measures financial risk. D/E greater than 2 is considered high. Related ratios Debt to Capital (D/C) and Debt to Assets (D/A). D/C or D/A less than .4 considered high.</p>
            <p>Note: Debt to Capital = Debt to Equity/(1 + Debt to Equity). Reinvestment Rate = (New Investment / NI)(1 – Debt to Capital). Net Debt = (Net Investment)(Debt to Capital).</p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.DEAVGtrend} decimalPrecision={1} displayType={"text"} />
          </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}>
          {symbol === "BRK-A" ? (
             <span className={left}> <a className="link blue" href={`https://www.reuters.com/companies/BRKa.N/key-metrics`} target="_blank">Avg. Payout:</a></span>
          ):(
             <span className={left}> <a className="link blue" href={`https://www.reuters.com/companies/${reutersData.CNNTicker}/key-metrics`} target="_blank">Avg. Payout:</a></span> 
          )} 
          <i data-tip data-for='payout' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='payout' place='top' class='mw6'>
            <p className="f6">Payout = Dividend/NI. 1 - (2 x Payout) used to approximate Distribution Rate.</p>
            <p>Note: Retention Rate = 1 – Payout.</p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.PayoutAvgCompany * 100} decimalPrecision={1} displayType={"text"} suffix={"%"} />
          </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}>
          
          {symbol === "BRK-A" ? (
              <span className={left}> <a className="link blue" href={`https://csimarket.com/stocks/BRKA-Return-on-Equity-ROE.html`} target="_blank">Avg. ROE:</a></span>
          ):(
            <span className={left}> <a className="link blue" href={`https://csimarket.com/stocks/${symbol}-Return-on-Equity-ROE.html`} target="_blank">Avg. ROE:</a></span>
          )} 
          
          
         
          <i data-tip data-for='ROE' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='ROE' place='top' class='mw6'>
            <p className="f6">ROE = NI/Equity. Used to approximate Return on Reinvestment (RoR). Exact calculation of RoR = EPS Growth/Reinvestment Rate.</p> 
            <p>Note: Reinvestment Rate = 1 – Distribution Rate. (1+EPS Growth) = (1+Total Sales Growth)(1+PM Growth)/(1+Shares Growth), use “Normalized earnings” in Current PM calculation.</p>
            <p>Note: Analysis gets real fuzzy when it comes to how much capital will be needed to support growth -- Bill Nygren, Oakmark Funds</p>
          </ReactTooltip>
          <span className={right}>
          <NumberFormat value={reutersData.ROEAvgCompany * 100} displayType={'text'} decimalPrecision={1} suffix={"%"}/>
        </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}>Competitive Advantage Years (Y):</span>
          <i data-tip data-for='CAY' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='CAY' place='top' class='mw6'>
            <p className="f6">The Polaris valuation formula contains 6 variables. The Polaris website has sliders for 3 of the variables (Sales Growth, Future PM, and Future PE) that are commonly modified.
            To calculate a valuation by modifying the other 3 variables (Y, Shares Growth, CoE) use the Polaris_Valuation spreadsheet located in the Polaris Dropbox public folder 
            (App_Polaris_Valuation subfolder). </p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.ExtrapY-3} decimalPrecision={0} displayType={"text"} />
          </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}> <a className="link blue" href={`http://www.market-risk-premia.com/us.html`} target="_blank">CoE:</a></span>
          <i data-tip data-for='CoC' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='CoC' place='top' class='mw6'>
            <p className="f6">Historical Cost of Equity (CoE) is the calculated risk adjusted rate of return.  CoE = Rf + (Stock Beta) x (Rm – Rf), where Rf is the risk-free rate of return (10 year Treasury note yield) and Rm is the historical market return (SP500 index).</p>
            <p>Note: Market Investment Return is the same as historical CoE. CoE is sometimes referred to as Ra or Cost of Capital (CoC) for the equity portion of a firm.</p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.RA1Round * 100} decimalPrecision={1} displayType={"text"} suffix={"%"} />
          </span></div>
        </li>
         <li className={liClass}> 
          <div className={padding}><span className={left}> <a className="link blue" href={`http://www.wolframalpha.com/input/?i=shares+outstanding+${symbol}`} target="_blank">Shares Issue Trend:</a></span>
          <span className={right}>
            <NumberFormat value={reutersData.ShrTrend * 100} decimalPrecision={1} displayType={"text"} suffix={"%"} />
          </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className={left}>Future Shares:</span>
          <i data-tip data-for='futureShares' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='futureShares' place='top' class='mw6'>
            <p className="f6">Expected shares in 5 years used in valuation calculations.</p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.ShrFuture} decimalPrecision={1} displayType={"text"} suffix={' M'}/>
          </span></div>
        </li>

        <li className={liClass}>
        <div className={padding}><span className={left}> <a className="link blue" href={`http://www.wolframalpha.com/input/?i=profit+margin+${symbol}`} target="_blank">Profit Margin (PM):</a></span>
        <i data-tip data-for='normalfuturePM' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='normalfuturePM' place='top' class='mw6'>
            <p className="f6">Profit Margin = Normalized Earnings/Sales in most recent completed fiscal year. Normalized earnings are the analysts’ consensus forecasted earnings for the end of the current fiscal year discounted backwards to the current date using an adjusted analysts’ consensus forecasted earnings growth. Earnings growth is adjusted using a proprietary method.</p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.NormalizedCurrentPM * 100} decimalPrecision={1} displayType={"text"} suffix={"%"} />
          </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className="orange">Default Future PM:</span>
          <i data-tip data-for='futurePM' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='futurePM' place='top' class='mw6'>
            <p className="f6">Earnings = Profit Margin * Sales. Profit Margin has a significant impact on earnings based valuations. Future PM is the maximum of company average PM and Industry average PM. If operations are dynamic, Sector average PM included in maximum as well. PM of 10% is used if no PM data available.</p>
          </ReactTooltip>
          <span className={right}>
            <NumberFormat value={reutersData.FuturePM * 100} decimalPrecision={1} displayType={"text"} suffix={"%"} />
          </span></div>
        </li>
        <li className={liClass}>
        <div className={padding}><span className={left}> <a className="link blue" href={`http://www.wolframalpha.com/input/?i=p%2Fe+${symbol}`} target="_blank">Avg. Price/Earnings (PE):</a></span>
          <span className={right}>
            <NumberFormat value={reutersData.PEAvgCompany} decimalPrecision={1} displayType={"text"} />
          </span></div>
        </li>
        <li className={liClass}>
          <div className={padding}><span className="orange">CoE Future PE:</span> <span className="black">(CoE = <NumberFormat value={1/(reutersData.CoEFuturePE-1)* 100} decimalPrecision={1} displayType={"text"} suffix={"%"} />)</span>
          <i data-tip data-for='futurePE' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='futurePE' place='top' class='mw6'>
            <p className="f6">Expected Price/Earnings at the end of the Competitive Advantage Period (CAP). Typical Future PE ranges from 12 (CoE 9%) to 18 (CoE 6%), average 15 (CoE 7%). To be conservative, Return on Reinvestment (RoR) assumed to mean revert to future Cost of Equity (CoE), thus Future PE = (1 + CoE)/CoE. Future CoE is more of a categorization than a calculation.</p>
            <p>Note: Future CoE = 1/(Future PE – 1)</p>
          </ReactTooltip>
          <span className={right}>
              <NumberFormat value={reutersData.CoEFuturePE} decimalPrecision={1} displayType={"text"} />
          </span></div>
        </li>
      </ul>
    </div>
  )
}

export default CompanyInfo



// WEBPACK FOOTER //
// ./src/components/CompanyInfo.js